import React, { useState, useEffect, useCallback } from "react"
import { DialogSystemGLPure } from "../../pures"
import DigitalVaultCategoriesAdministrationDetailsView from "./digital-vault-categories-administration-details.view";
import DigitalVaultCategoriesAdministrationNewSubcategory from "./digital-vault-categories-administration-new-subcategory.view";
import DigitalVaultCategoriesAdministrationAddCategory from "./digital-vault-categories-administration-new-category.view";
import DigitalVaultCategoriesAdministrationSubcategoryDetailsView from "./digital-vault-categories-administration-subcategory-details.view"
import { CategoryService } from "../../../services";
import { LocalStorageService } from "../../../services";
import { NIL } from "uuid";
import { useTranslation } from "react-i18next";

const DigitalVaultCategoriesAdministrationConfigurationsView = (props) => {
    const {
        routes,
        selectedSubcategory,
        defaultCategories,
        nameComponentUser,
        selectedUser,
        setShowDetails,
        updateCategories,
        loadingRequesting,
        toggleLoadingRequesting,
        completedRequesting,
        toggleCompletedRequesting,
        errorRequesting,
        toggleErrorRequesting,
        showWarningRequesting,
        toggleWarningRequesting,
        setMessage,
        selectedValueFilter,
        setSelectedValue,
        categories,
        setCategories,
        updateSubcategories
    } = props
    const localStorageService = new LocalStorageService()
    const categoryService = new CategoryService(process.env.REACT_APP_MIFIRMA_API)
    const [stateNameComponentUser, setStateNameComponentUser] = useState("");
    const { t } = useTranslation()
    const token = localStorageService.getLocalStorageItem("token").idToken

    // Local confirmation state (Tabla 3)
    const [showConfirm, setShowConfirm] = useState(false)
    const [confirmTitle, setConfirmTitle] = useState("")
    const [confirmMessage, setConfirmMessage] = useState("")
    const [confirmChildren, setConfirmChildren] = useState(null)
    const [confirmSubmit, setConfirmSubmit] = useState(() => () => { })

    // Helper: contextual content with only Nombre y Fecha de registro
    const renderConfirmChildren = ({ name, dateCreated }) => (
        <div className='dialogSystemHLPure-warning-container-items'>
            <p><b>{t('syncFusion.file.manager.confirm.name.category')}</b> {name || '-'}</p>
            {dateCreated ? (<p><b>{t('syncFusion.file.manager.confirm.date.registration')}</b> {dateCreated}</p>) : null}
        </div>
    )

    const updateCategory = async (categoryName, notes, levelUser, companyId, icon) => {
        toggleLoadingRequesting(true)
        let updateCategory
        try {
            (companyId === NIL || !companyId)
                ? updateCategory = await categoryService.updateCategory(categoryName, notes, levelUser, null, icon, token)
                : updateCategory = await categoryService.updateCategory(categoryName, notes, levelUser, companyId, icon, token)

            if (!updateCategory.data) throw new Error(updateCategory.message)

            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                await updateCategories()
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    const assignCategory = async (categoryId, levelUser, companyId, notes) => {
        toggleLoadingRequesting(true)
        let assignCategory
        try {
            companyId === NIL ?
                assignCategory = await categoryService.assignCategory(categoryId, levelUser, null, notes, token)
                : assignCategory = await categoryService.assignCategory(categoryId, levelUser, companyId, notes, token)

            if (!assignCategory.data) throw new Error(assignCategory.message)

            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                await updateCategories()
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                setMessage("")
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    const createCategory = async (categoryName, levelUser, companyId, notes, icon) => {
        toggleLoadingRequesting(true)
        let createdCategory
        try {
            companyId === NIL
                ? createdCategory = await categoryService.createCategory(categoryName, "", "", levelUser, null, notes, icon, token)
                : createdCategory = await categoryService.createCategory(categoryName, "", "", levelUser, companyId, notes, icon, token)

            if (!createdCategory.data) throw new Error(createdCategory.message)

            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                await updateCategories()
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                setMessage("")
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    const createSubcategory = async (categoryName, levelUser, companyId, notes, level, parent) => {
        toggleLoadingRequesting(true)
        let createdSubcategory
        try {
            if (!companyId || companyId === NIL) {
                createdSubcategory = await categoryService.createSubcategory(categoryName, "", "", levelUser, null, notes, level, "Sub", parent, token)
            } else {
                createdSubcategory = await categoryService.createSubcategory(categoryName, "", "", levelUser, companyId, notes, level, "Sub", parent, token)
            }
            if (!createdSubcategory.data) {
                throw new Error(createdSubcategory.message)
            }
            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                await updateSubcategories(companyId, parent)
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                setMessage("")
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    const updateSubcategory = async (categoryName, notes, levelUser, companyId) => {
        toggleLoadingRequesting(true)
        let updateCategory
        try {
            (companyId === NIL || !companyId)
                ? updateCategory = await categoryService.updateSubcategory(categoryName, notes, levelUser, null, token)
                : updateCategory = await categoryService.updateSubcategory(categoryName, notes, levelUser, companyId, token)
            if (!updateCategory.data) {
                throw new Error("Ha ocurrido un error al crear la categoría")
            }
            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                selectedValueFilter === NIL
                    ? await updateSubcategories(null, selectedSubcategory.parent)
                    : await updateSubcategories(selectedValueFilter, selectedSubcategory.parent)
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                setMessage("")
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    const unassignCategory = async (companyId, categoryId) => {
        toggleLoadingRequesting(true)
        let unassignCategory
        try {
            (companyId === NIL || !companyId)
                ? unassignCategory = await categoryService.unassignCategory(companyId, categoryId, token)
                : unassignCategory = await categoryService.unassignCategory(companyId, categoryId, token)
            if (!unassignCategory.data) throw new Error(unassignCategory.message)
            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                await updateCategories()
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                setMessage("")
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    // Actual API call for category delete
    const performDeleteCategory = async (companyId, categoryId) => {
        toggleLoadingRequesting(true)
        let deleteCategory
        try {
            !companyId ? deleteCategory = await categoryService.deleteCategory("", categoryId, token) : deleteCategory = await categoryService.deleteCategory(companyId, categoryId, token)
            if (!deleteCategory.data) {
                throw new Error(deleteCategory.message)
            }

            if (deleteCategory && deleteCategory.data && Number(deleteCategory.data.statusCode) === -5) {
                toggleLoadingRequesting(false)
                toggleWarningRequesting(true)
                setMessage(`No es posible eliminar la categoría ya que cuenta con documentos asignados.`)
                setTimeout(async () => {
                    toggleWarningRequesting(false)
                }, 5000)
                return
            }

            toggleLoadingRequesting(false)
            toggleCompletedRequesting(true)
            setTimeout(async () => {
                toggleCompletedRequesting(false)
                await updateCategories()
                setStateNameComponentUser("")
                setShowDetails(false)
            }, 2000);
        } catch (e) {
            setMessage(e.message)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                setMessage("")
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    // Wrapper: open confirm dialog per Tabla 3
    const deleteCategory = (companyId, categoryId) => {
        const name = selectedUser?.name
        const date = selectedUser?.dateCreated || selectedUser?.createdAt || null
        setConfirmTitle('Eliminar categoría')
        setConfirmMessage('¿Estás seguro de que deseas eliminar esta categoría?')
        setConfirmChildren(renderConfirmChildren({ name, dateCreated: date }))
        setConfirmSubmit(() => () => performDeleteCategory(companyId, categoryId))
        setShowConfirm(true)
    }

    // Actual API call for subcategory delete
    const performDeleteSubcategory = async (companyId, categoryId) => {
        toggleLoadingRequesting(true)
        let deleteCategory
        try {
            !companyId ? deleteCategory = await categoryService.deleteSubcategory("", categoryId, token) : deleteCategory = await categoryService.deleteSubcategory(companyId, categoryId, token)
            if (deleteCategory.statusCode === 200) {
                switch (deleteCategory.data.code) {
                    case 1:
                        toggleLoadingRequesting(false)
                        toggleWarningRequesting(true)
                        setMessage(`Se han eliminado las siguientes subcategorías: ${deleteCategory.data.categoriesWoutDocumentsNames}.\n
                        Sin embargo, estas categorías cuentan con documentos, por lo que no fue posible eliminarlas: ${deleteCategory.data.categoriesWithDocumentsNames}`)
                        setTimeout(async () => {
                            toggleWarningRequesting(false)
                            selectedValueFilter === NIL
                                ? await updateSubcategories(null, selectedSubcategory.parent)
                                : await updateSubcategories(selectedValueFilter, selectedSubcategory.parent)
                            setMessage("")
                            setStateNameComponentUser("")
                            setShowDetails(false)
                        }, 10000)
                        break
                    case 2:
                        toggleLoadingRequesting(false)
                        toggleWarningRequesting(true)
                        setMessage(`Se han eliminado correctamente las siguientes las siguientes subcategorías: ${deleteCategory.data.categoriesWoutDocumentsNames}.`)
                        setTimeout(async () => {
                            toggleWarningRequesting(false)
                            selectedValueFilter === NIL
                                ? await updateSubcategories(null, selectedSubcategory.parent)
                                : await updateSubcategories(selectedValueFilter, selectedSubcategory.parent)
                            setMessage("")
                            setStateNameComponentUser("")
                            setShowDetails(false)
                        }, 10000)
                        break
                    case 3:
                        toggleLoadingRequesting(false)
                        toggleCompletedRequesting(true)
                        setMessage(`La categoría fue eliminada correctamente.`)
                        setTimeout(async () => {
                            toggleCompletedRequesting(false)
                            selectedValueFilter === NIL
                                ? await updateSubcategories(null, selectedSubcategory.parent)
                                : await updateSubcategories(selectedValueFilter, selectedSubcategory.parent)
                            setMessage("")
                            setStateNameComponentUser("")
                            setShowDetails(false)
                        }, 3000)
                        break
                    case 4:
                        toggleLoadingRequesting(false)
                        toggleWarningRequesting(true)
                        setMessage(`No es posible eliminar la subcategoría ya que cuenta con documentos asignados.`)
                        setTimeout(async () => {
                            toggleWarningRequesting(false)
                            selectedValueFilter === NIL
                                ? await updateSubcategories(null, selectedSubcategory.parent)
                                : await updateSubcategories(selectedValueFilter, selectedSubcategory.parent)
                            setMessage("")
                            setStateNameComponentUser("")
                            setShowDetails(false)
                        }, 10000)
                        break
                    default:
                        toggleLoadingRequesting(false)
                        toggleWarningRequesting(true)
                        setMessage(`No fue posible completar la operación de eliminación.`)
                        setTimeout(async () => {
                            toggleWarningRequesting(false)
                            selectedValueFilter === NIL
                                ? await updateSubcategories(null, selectedSubcategory.parent)
                                : await updateSubcategories(selectedValueFilter, selectedSubcategory.parent)
                            setMessage("")
                            setStateNameComponentUser("")
                            setShowDetails(false)
                        }, 5000)
                        break
                }
            } else {
                throw Error("Ha ocurrido un error. Si el problema persiste, contacta a soporte técnico.")
            }
        } catch (e) {
            setMessage("")
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                toggleErrorRequesting(false)
            }, 3000)
        }
    }

    // Wrapper: open confirm dialog per Tabla 3
    const deleteSubcategory = (companyId, categoryId) => {
        const name = selectedSubcategory?.name || selectedUser?.name
        const date = selectedSubcategory?.dateCreated || selectedSubcategory?.createdAt || selectedUser?.dateCreated || selectedUser?.createdAt || null
        setConfirmTitle('Eliminar subcategoría')
        setConfirmMessage('¿Estás seguro de que deseas eliminar esta subcategoría?')
        setConfirmChildren(renderConfirmChildren({ name, dateCreated: date }))
        setConfirmSubmit(() => () => performDeleteSubcategory(companyId, categoryId))
        setShowConfirm(true)
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setStateNameComponentUser(nameComponentUser);
    }, [nameComponentUser]);

    useEffect(() => {
        renderComponentUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateNameComponentUser, selectedUser]);

    const renderComponentUser = useCallback(() => {
        switch (stateNameComponentUser) {
            case t("digitalVaultCategoriesAdministration.main.title.seeDetails"):
                return (
                    <DigitalVaultCategoriesAdministrationDetailsView
                        setCategories={setCategories}
                        selectedUser={selectedUser}
                        selectedValueFilter={selectedValueFilter}
                        setSelectedValue={setSelectedValue}
                        categories={categories}
                        setShowDetails={setShowDetails}
                        updateCategory={updateCategory}
                        unassignCategory={unassignCategory}
                        deleteCategory={deleteCategory}
                        loadingRequesting={loadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        completedRequesting={completedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        errorRequesting={errorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting} />
                );
            case t("digitalVaultCategoriesAdministration.main.title.seeDetailsSubcategory"):
                return (
                    <DigitalVaultCategoriesAdministrationSubcategoryDetailsView
                        setCategories={setCategories}
                        selectedUser={selectedSubcategory}
                        selectedValueFilter={selectedValueFilter}
                        setSelectedValue={setSelectedValue}
                        categories={categories}
                        setShowDetails={setShowDetails}
                        deleteSubcategory={deleteSubcategory}
                        updateSubcategory={updateSubcategory}
                        loadingRequesting={loadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        completedRequesting={completedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        errorRequesting={errorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting} />
                );
            case t("digitalVaultCategoriesAdministration.main.addCategory"):
                return (
                    <DigitalVaultCategoriesAdministrationAddCategory
                        defaultCategories={defaultCategories}
                        setCategories={setCategories}
                        selectedUser={selectedUser}
                        setSelectedValue={setSelectedValue}
                        categories={categories}
                        selectedValueFilter={selectedValueFilter}
                        setShowDetails={setShowDetails}
                        loadingRequesting={loadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        completedRequesting={completedRequesting}
                        errorRequesting={errorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        assignCategory={assignCategory}
                        createCategory={createCategory} />
                )
            case t("digitalVaultCategoriesAdministration.subcategories.addCategory"):
                return (
                    <DigitalVaultCategoriesAdministrationNewSubcategory
                        routes={routes}
                        defaultCategories={defaultCategories}
                        setCategories={setCategories}
                        selectedUser={selectedUser}
                        setSelectedValue={setSelectedValue}
                        categories={categories}
                        selectedValueFilter={selectedValueFilter}
                        setShowDetails={setShowDetails}
                        loadingRequesting={loadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        completedRequesting={completedRequesting}
                        errorRequesting={errorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        createSubcategory={createSubcategory}
                    />
                )
            default:
                return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateNameComponentUser]);

    return <>
        {renderComponentUser()}
        {showWarningRequesting && (
            <DialogSystemGLPure
                showWarningRequesting={showWarningRequesting}
                toggleWarningRequesting={toggleWarningRequesting}
            />
        )}
        {showConfirm && (
            <DialogSystemGLPure
                showConfirm={showConfirm}
                confirmTitle={confirmTitle}
                confirmMessage={confirmMessage}
                confirmChildren={confirmChildren}
                handleConfirmDeleteFlowClose={() => setShowConfirm(false)}
                handleConfirmDeleteFlowSubmit={() => {
                    try { confirmSubmit() } finally { setShowConfirm(false) }
                }}
                labelCancelConfirmation={t('button.cancel')}
                labelSubmitConfirmation={t('button.delete')}
            />
        )}
    </>;
};

export default DigitalVaultCategoriesAdministrationConfigurationsView